import { ReactNode, useRef, useEffect } from 'react'
import './VideoBackground.css'

interface VideoBackgroundProps {
  children?: ReactNode
  className?: string
  webmSrc?: string
  mp4Src?: string
  poster?: string
}

const VideoBackground = ({ children, className = '', webmSrc, mp4Src, poster }: VideoBackgroundProps) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = videoRef.current
    if (video && (webmSrc || mp4Src)) {
      video.play().catch(() => {
        // Autoplay was prevented, handle gracefully
      })
    }
  }, [webmSrc, mp4Src])

  return (
    <div className={`video-background ${className}`}>
      <div className="video-background-media">
        {(webmSrc || mp4Src) ? (
          <video
            ref={videoRef}
            className="video-background-video"
            autoPlay
            loop
            muted
            playsInline
            poster={poster}
          >
            {webmSrc && <source src={webmSrc} type="video/webm" />}
            {mp4Src && <source src={mp4Src} type="video/mp4" />}
            Your browser does not support the video tag.
          </video>
        ) : null}
      </div>
      {children && <div className="video-background-content">{children}</div>}
    </div>
  )
}

export default VideoBackground
